import styled from "styled-components";

import { Link } from "_/components/router";

export const ProjectCard = styled(Link)`
  display: grid;
  align-content: space-between;
  align-items: start;
  gap: 1rem;
  padding: 1rem 1rem 1rem 1.25rem;
  background-color: ${(p) => p.theme.background.secondary};
  transition: background-color 0.1s ease;
  &:hover {
    background-color: ${(p) => p.theme.background.tertiary};
  }
  border-radius: 4px;
`;

export const FirstRowContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: start;
  gap: 1rem;
  height: 2.5rem;
`;

export const SecondRowContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const CardMeta = styled.span`
  font-size: 0.75rem;
  & > label {
    color: ${(p) => p.theme.text.muted};
    font-weight: 600;
  }
  & > div {
    color: ${(p) => p.theme.text.default};
  }
`;

export const CardMetaContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin: auto 0 0;
  padding-right: 0.5rem;
`;

export const ProjectName = styled.div`
  max-height: 2.5rem;
  line-height: 1.25rem;
  overflow: hidden;
  overflow-wrap: anywhere;
`;

export const ProjectCards = styled.ul`
  display: grid;
  gap: 1.5rem;
  list-style: none;
  margin: 0;
  padding: 0;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
`;

export const ArchivedHeader = styled.div`
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
  padding-top: 2.5rem;
  padding-bottom: 1.5rem;
`;

export const EmptyProjectsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 0.5rem;
  padding: 1rem 1rem 1rem 1.25rem;
  min-height: 150px;
  min-width: 300px;
  font-size: 0.95rem;
  background-color: ${(p) => p.theme.background.secondary};
  border-radius: 4px;
  span {
    font-size: 2rem;
    color: ${(p) => p.theme.text.muted};
  }
`;
